import React, { Component } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Card from '../Common/Card';
import PageHeader from '../Common/PageHeader';

import qs from 'query-string';
import { withRouter } from 'react-router-dom';
import 'react-tabs/style/react-tabs.css';
import StatesService from '../../Service/StatesService';
import UserService from '../../Service/UserService';
import Dropdown from '../ui/Dropdown';
import Details from './Details';
import FundingSources from './FundingSources';
import Loans from './Loans';
import Notifications from './Notifications';
import Plaid from './Plaid';
import Transactions from './Transactions';

import TabsWallet from './Transactions/TabsWallet';


class Customer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_selectedIndex: 0,
			_heading: '...',
			_tabsRoute: ['tab=0', 'tab=1', 'tab=2', 'tab=3', 'tab=4', 'tab=5'],
			_setStatus:
				qs.parse(window.location.search).status === 'PAYMENTS_STOPED'
					? 'PAUSED'
					: qs.parse(window.location.search).status === 'PRE_MODIFIED' ||
					  qs.parse(window.location.search).status === 'POST_MODIFIED'
					? 'MODIFIED'
					: qs.parse(window.location.search).status
		};
	}

	setHeading = heading => {
		this.setState({
			_heading: heading,
			_customer: null,
			_noCustomerFound: false
		});
	};

	onSelect = async (index, lastIndex) => {
		const { _tabsRoute } = this.state;
		const currentQuery = qs.parse(window.location.search);

		_tabsRoute[lastIndex] = qs.stringify(currentQuery);
		this.props.history.push({
			search: qs.stringify(qs.parse(_tabsRoute[index]))
		});
		this.setState({
			_tabsRoute
		});
	};

	retainStateFromQueryParameter = async () => {
		const queryItems = qs.parse(window.location.search);
		const { _tabsRoute } = this.state;
		if (queryItems.tab) {
			_tabsRoute[Number(queryItems.tab)] = qs.stringify(queryItems);
		}
		this.setState({
			_tabsRoute,
			_selectedIndex: queryItems.tab || 0
		});
	};

	setCustomerDetais = async () => {
		const _customer = await UserService.getUserById(this.props.match.params.id);
		if (_customer) {
			if (_customer.state) {
				const stateData = await StatesService.getStateById(_customer.state);
				if (stateData && stateData.name) {
					_customer.state = stateData.name;
				}
			}
			if (_customer.first_name && _customer.last_name) {
				this.setState({
					_customer,
					_heading: `${_customer.first_name} ${_customer.last_name}`
				});
			}
		} else {
			this.setState({
				_noCustomerFound: true
			});
		}
	};

	componentDidMount() {
		this.setCustomerDetais();
		this.retainStateFromQueryParameter();
	}

	componentDidUpdate(nextProps) {
		if (nextProps.location.search !== this.props.location.search) {
			const queryItems = qs.parse(window.location.search);
			console.log(queryItems.tab || 0);
			this.retainStateFromQueryParameter();
		}
	}

	componentDidUpdate(nextProps) {
		if (nextProps.location.search !== this.props.location.search) {
			const queryItems = qs.parse(window.location.search);

			this.retainStateFromQueryParameter();
		}
	}

	render() {
		// NOSONAR
		const { match } = this.props;
		const { id } = this.props.match.params;

		return (
			<>
				<PageHeader text={this.state._heading} />

				<Card>
					{match.path === '/admin/customer/custom-view/:id' ? (
						<Tabs onSelect={this.onSelect} selectedIndex={Number(this.state._selectedIndex) || 0}>
							<TabList>
								<Tab>User Profile</Tab>

								<Tab>Loan List</Tab>
								<Tab>Transaction History</Tab>
							</TabList>

							<TabPanel>
								<Details
									{...this.props}
									_customer={this.state._customer}
									_noCustomerFound={this.state._noCustomerFound}
								/>
							</TabPanel>

							<TabPanel>
								<div
									style={{
										margin: '30px auto',

										padding: '20px ',
										border: '1px solid rgba(0,0,0,0.2)'
									}}>
									<div className="col-3">
										<Dropdown
											onChange={e => {
												e.preventDefault();
												if (qs.parse(window.location.search).status) {
													const parsedUrl = qs.parse(window.location.search);

													delete parsedUrl.status;

													const updatedUrl = qs.stringify(parsedUrl);

													window.history.replaceState(
														null,
														'',
														window.location.pathname + '?' + updatedUrl
													);
												}

												let currentUrl = window.location.href;
												let status;
												currentUrl = currentUrl.replace(/([&?]status=)[^&]+(&|$)/, '$2');

												if (e.target.value === 'MODIFIED') {
													status = 'PRE_MODIFIED';
												} else if (e.target.value === 'PAUSED') {
													status = 'PAYMENTS_STOPED';
												} else if (e.target.value === 'ALL') {
													status =
														'PENDING,DECLINE,DELETED,APPROVE,POST_MODIFIED,PRE_MODIFIED,COMPLETED,PAYMENTS_STOPED';
												} else {
													status = e.target.value;
												}

												currentUrl +=
													(currentUrl.includes('?') ? '&' : '?') + 'status=' + status;
												window.location.href = currentUrl;

												this.setState({
													_setStatus: e.target.value
												});
											}}
											title="Status"
											value={this.state._setStatus}
										/>
									</div>
								</div>

								<Loans {...this.props} status={this.state._setStatus} />
							</TabPanel>
							<TabPanel>
								{this.props.match.path === '/admin/customer/custom-view/:id' ? (
									<TabsWallet />
								) : (
									<Transactions {...this.props} />
								)}
							</TabPanel>
						</Tabs>
					) : (
						<Tabs onSelect={this.onSelect} selectedIndex={Number(this.state._selectedIndex) || 0}>
							<TabList>
								<Tab>Details</Tab>
								<Tab>Funding Sources</Tab>
								<Tab>Loans</Tab>
								<Tab>Transactions</Tab>
								<Tab>Notification</Tab>
								<Tab>Plaid</Tab>
							</TabList>

							<TabPanel>
								<Details
									{...this.props}
									_customer={this.state._customer}
									_noCustomerFound={this.state._noCustomerFound}
								/>
							</TabPanel>
							<TabPanel>
								<FundingSources {...this.props} />
							</TabPanel>
							<TabPanel>
								<Loans {...this.props} />
							</TabPanel>
							<TabPanel>
								<Transactions {...this.props} />
							</TabPanel>
							<TabPanel>
								<Notifications {...this.props} />
							</TabPanel>
							<TabPanel>
								<Plaid {...this.props} />
							</TabPanel>
						</Tabs>
					)}
				</Card>
			</>
		);
	}
}
export default withRouter(Customer);
